export const PAGE_HOME_PATH = '/';
export const PAGE_LOGIN_PATH = '/login';
export const PAGE_USER_MANAGEMENT_PATH = '/user-management';
export const PAGE_CUSTOMERS_PATH = '/customers';
export const PAGE_E_MAIL_TRACKER_PATH = '/e-mail-tracker';
export const PAGE_SALES_PATH = '/sales';
export const PAGE_LICENSES_PATH = '/licenses';
export const PAGE_LOGS_PATH = '/logs'
export const PAGE_AI_PATH = '/ai';
